import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MonacoPageComponent } from './components/monaco-editor/monaco-editor.component';
import { MonacoDiffPageComponent } from './components/monaco-diff-editor/monaco-diff-editor.component';
@NgModule({
  imports: [
    CommonModule,
    MonacoDiffPageComponent,
    MonacoPageComponent,
  ],
  exports: [
    MonacoDiffPageComponent,
    MonacoPageComponent,
  ],
})
export class LTMonacoModule { }